/**
 * 문자열 시드 기반 의사난수 생성기 (샘플 가상 데이터 전용)
 * - 같은 시드(조회 범위·기간 등)면 항상 같은 값이 나오도록 해 화면이 새로고침마다 바뀌지 않게 합니다.
 * - 실제 API 연동 후에는 사용하지 않습니다.
 */
const seededRandom = (seedText) => {
  let h = 1779033703 ^ seedText.length;
  for (let i = 0; i < seedText.length; i += 1) {
    h = Math.imul(h ^ seedText.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  return () => {
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    h ^= h >>> 16;
    return (h >>> 0) / 4294967296;
  };
};

/** 조회 범위별 전체 참가자 수 — 전체 기관(ALL)은 여러 기관 합산 규모로 크게 잡음 (종합현황·참가자 관리 공용) */
export const getSampleOrgTotal = (scopeKey) =>
  scopeKey === "ALL" ? 412 : 60 + Math.floor(seededRandom(scopeKey)() * 100);

export default seededRandom;
